  import * as ActionTypes from "../Types/ActionTypes";

  export const SiteDashboard = (
    state = {
      isLoading: false,
      siteDashboardState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.SITE_DASHBOARD_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.SITE_DASHBOARD:
        return {
          ...state,
          isLoading: false,
          siteDashboardState: action.payload,
        };

      case ActionTypes.SITE_DASHBOARD_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
